// tslint:disable

import { Vue } from "vue-property-decorator";
import store from "@/store/store";
import * as signalR from "@microsoft/signalr";
import { NotificationService } from "@/services/notification.service";
import { EventAction, Job, JobEvent } from '@/models/job.model';
import { PinBoard } from "@/models/pinboard.model";
import { AssignedJob } from "@/models/assignedJob.model";
import { setting } from '@/common/settings';

export abstract class SocketHelper {
    static async addToGroup(group: string) {
        //@ts-ignore
        await state.connection.invoke("AddToGroup", group);
    };
}

export interface NotificationstateInterface {
    isConnected: boolean;
    message:string;
    connection: any;
}

const state = {
    isConnected: false,
    message: "",
    connection: {},
} as NotificationstateInterface;

const getters = {
    isConnected: (appSocket: any) => (appSocket.connection && appSocket.connection.connectionState == "Connected") ? true : false,
    conncetionState: (appSocket: any) => appSocket.connection && appSocket.connection.connectionState,
}
const actions = {
    toggleConnection: async ({ commit, dispatch }: { commit: any, dispatch: any }, group:string) => {
        //@ts-ignore
        await state.connection.invoke("AddToGroup", group);
    },
    initConnection: async ({ commit, dispatch }: { commit: any, dispatch: any }) => {
        console.log("Starting SignalR...");
        const url = setting.HubUrl.current; // + "?customerId=18";

        commit("mSetConnection", url);
        try {
            await state.connection.start();
            //@ts-ignore
            dispatch("toggleConnection", store.getters["app/companyId"]);
            if (store.getters["auth/hasManagement"]) {
                dispatch("toggleConnection", store.getters["auth/managementId"]);
            }
        } catch (err) {
            console.log(err);
            setTimeout(async () => await dispatch("initConnection"), 5000);
            return;
        }

        // Here status is signalR.HubConnectionState.Connected
        console.assert(
            state.connection.state === signalR.HubConnectionState.Connected
        );
        console.log("SignalR Connected!");

        state.connection.invoke.apply;

        await state.connection.on("JobEvent", async (response: any) => {
            let parsed = JSON.parse(response);
            let object: Job = <Job>parsed.data;

            // CREATE
            if (parsed.action == 1) {
                if (store.getters["app/currentPinBoardId"] != object.pinBoardId) {
                    store.dispatch("job/addToJobEvent", { jobId: object.id, pinboardId: object.pinBoardId, action: parsed.action } as JobEvent)
                }
                else {

                    store.dispatch("job/getJobsOnPinBoard", store.getters["app/currentPinBoardId"]);

                }
            }

            // UPDATE
            if (parsed.action == 2) {
                await store.dispatch("job/getJobsOnPinBoard", store.getters["app/currentPinBoardId"]);
            }

            // DONE
            if (parsed.action == 4) {
                console.log(object);
                console.log(store.getters["job/currentAssignedJobs"]);

                if(!store.getters["job/currentAssignedJobs"].some((aj :AssignedJob) => aj.done && aj.id == object.id )){
                    await store.dispatch("job/getJobsOnPinBoard", store.getters["app/currentPinBoardId"]);
                }
            }
        });

        await state.connection.on("PinboardEvent", async (response: any) => {
            let parsed = JSON.parse(response);
            let object: PinBoard = <PinBoard>parsed.data;
            if (parsed.action == 1) {
                await store.dispatch("app/getCompanyPinBoards");
            }
            if (parsed.action == 3) {
                await store.dispatch("app/getCompanyPinBoards");
            }
        });

        await state.connection.onreconnected(async (connectionId: any) => {
            await SocketHelper.addToGroup(store.getters["app/companyId"]);
            if (store.getters["auth/hasManagement"]) {
                await SocketHelper.addToGroup(store.getters["auth/managementId"]);
            }
        });

        //@ts-ignore

        // When connection is lost and signalr is trying to autoreconnect
        state.connection.onreconnecting((_error: any) => {
            console.log("SignalR onreconnecting()");
        });

        // When connection is reestablished from autoreconnect
        state.connection.onreconnected((_connectionId: any) => {
            console.log("SignalR onreconnected()");
        });

        // When connection is permanently lost (i.e. couldn't reconnect even after all the attempts)
        state.connection.onclose((_error: any) => {
            console.log("SignalR onclose()");
            // inform user that connection is lost and recommend refreshing the page

            // Continuosly try to reconnect
            setTimeout(async () => await dispatch("initConnection"), 5000);
        });
    },
    // init: async ({ commit, dispatch }: { commit: any, dispatch: any }, url: string) => {
    //     commit("INIT_CONNECTION", url);
    // },
    // connect: async ({ commit, dispatch }: { commit: any, dispatch: any }) => {
    //     await commit("CONNECT");
    // },
};



// tslint:disable-next-line:typedef
const mutations = {
    mSetConnection: (state: any, url: string) => {
        const signalrOptions = {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
        };
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(url, signalrOptions)
            .withAutomaticReconnect([0, 0, 2000, 5000, 10000])
            .configureLogging(signalR.LogLevel.Information)
            .build();

        state.connection = connection;

    },
    // INIT_CONNECTION: (socketState: any, url: string) => {
    //     socketState.connection = new HubConnectionBuilder().withUrl(url, {
    //         skipNegotiation: true,
    //         transport: HttpTransportType.WebSockets
    //     })
    //         .withAutomaticReconnect([0, 0, 2000, 5000, 10000])
    //         .build();
    // },
    // CONNECT: async (socketState: any) => {
    //     await socketState.connection.start();

    //     await SocketHelper.addToGroup(store.getters["app/companyId"]);
    //     if (store.getters["auth/hasManagement"]) {
    //         await SocketHelper.addToGroup(store.getters["auth/managementId"]);
    //     }

    //     await socketState.connection.on("JobEvent", async (response: any) => {
    //         let parsed = JSON.parse(response);
    //         let object: Job = <Job>parsed.data;

    //         // CREATE
    //         if (parsed.action == 1) {
    //             if (store.getters["app/currentPinBoardId"] != object.pinBoardId) {
    //                 store.dispatch("job/addToJobEvent", { jobId: object.id, pinboardId: object.pinBoardId, action: parsed.action } as JobEvent)
    //             }
    //             else {

    //                 store.dispatch("job/getJobsOnPinBoard", store.getters["app/currentPinBoardId"]);

    //             }
    //         }

    //         // UPDATE
    //         if (parsed.action == 2) {
    //             await store.dispatch("job/getJobsOnPinBoard", store.getters["app/currentPinBoardId"]);
    //         }

    //         // DONE
    //         if (parsed.action == 4) {
    //             console.log(object);
    //             console.log(store.getters["job/currentAssignedJobs"]);

    //             if(!store.getters["job/currentAssignedJobs"].some((aj :AssignedJob) => aj.done && aj.id == object.id )){
    //                 await store.dispatch("job/getJobsOnPinBoard", store.getters["app/currentPinBoardId"]);
    //             }
    //         }
    //     });

    //     await socketState.connection.on("PinboardEvent", async (response: any) => {
    //         let parsed = JSON.parse(response);
    //         let object: PinBoard = <PinBoard>parsed.data;
    //         if (parsed.action == 1) {
    //             await store.dispatch("app/getCompanyPinBoards");
    //         }
    //         if (parsed.action == 3) {
    //             await store.dispatch("app/getCompanyPinBoards");
    //         }
    //     });

    //     await socketState.connection.onreconnected(async (connectionId: any) => {
    //         await SocketHelper.addToGroup(store.getters["app/companyId"]);
    //         if (store.getters["auth/hasManagement"]) {
    //             await SocketHelper.addToGroup(store.getters["auth/managementId"]);
    //         }
    //     });
    // },
    // ADD_TO_GROUP: async (socketState: any, group: string) => {
    //     await socketState.connection.invoke("AddToGroup", group)
    // }


};


export default {
    state,
    getters,
    actions,
    mutations
};

// tslint:enable